import React, { useState } from "react";

import { SwapOutlined } from "@ant-design/icons";

// Components
import { Product } from "../../../../../interfaces/products";
import { Button } from "../ProductInfo.styles";

import { ConvertToVirtualKitModal } from ".";

interface Props {
  organizationId: string;
  product: Product;
  onRefetchProduct: () => unknown;
}

const ConvertToVirtualKitButton: React.FC<Props> = ({ organizationId, product, onRefetchProduct }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isConvertingProduct, setIsConvertingProduct] = useState(false);
  return (
    <>
      <Button
        margin="0 16px 0 0"
        onClick={() => setIsModalVisible(true)}
        icon={<SwapOutlined />}
        disabled={isConvertingProduct}
      >
        Convert to Virtual Kit
      </Button>
      <ConvertToVirtualKitModal
        organizationId={organizationId}
        product={product}
        isModalVisible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onConvertingProduct={() => setIsConvertingProduct(true)}
        onRefetchProduct={onRefetchProduct}
      />
    </>
  );
};

export { ConvertToVirtualKitButton };
